import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    mapJsonToReportClientiVersoreApiResponse, ReportClientiVersoreApiResponse
} from "./types";
import {EmailForm} from "../reports/types";
import AxiosInstanceUpload from "../../components/AxiosUpload";
import * as Yup from "yup";
import {Buffer} from "buffer";
import {format} from "date-fns";
import {sortingParam, columnFiltersParamWithDateRange} from "../../common/Services";

const moment = require('moment')

export function useGetAllReportClientiVersore(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<ReportClientiVersoreApiResponse>({
        queryKey: [
            'fetchReportClientiVersore',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {

            // const isadmin = localStorage.getItem(IS_ADMIN_KEY) === 'true'; // Ensures isadmin is treated as a boolean
            let codclifor = localStorage.getItem('keycodclifor') || '';

            const role = localStorage.getItem('keyrole') || '';

            const idazienda = localStorage.getItem('keyidazienda') || '';

            // console.log('codclifor: ',codclifor);


            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;



            let myURL = `?limit=${pagination.pageSize}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT51'
            )}&ordering=${sortingParam(sorting, 'VBT51')}`;


             if (role.includes('TimeReportAdmin')){
                        myURL += `&VBT51_DITTA=${idazienda}&VBT51_FLGVAL=Y`;
                } else {
                        myURL += `&VBT51_CODCLI=${codclifor}&VBT51_DITTA=${idazienda}&VBT51_FLGVAL=Y`;
             }


            const response = await AxiosInstance.get(`reportclientiversore/${myURL}`);

             // Fetch the data using the constructed URL
            // const response = await AxiosInstance.get(
            //     `reportclientiversore/${myURL}&VBT51_CODCLI=${codclifor}&VBT51_DITTA=${idazienda}&VBT51_FLGVAL=Y`
            //
            // );

            return mapJsonToReportClientiVersoreApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}

export function useSendEmail() {
  return useMutation({
    mutationFn: async (emailForm: EmailForm) => {
      return AxiosInstance.post('sendemail/', emailForm);
    },
  });
}

export function useUploadReport() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      return AxiosInstanceUpload.post('uploadreport/', formData);
    },
  });
}


export const validationSchema = Yup.object().shape({
                      fromDate: Yup.date().required('Selezione Data Inizio'),
                      toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                                         const { fromDate } = this.parent; // Access fromDate from parent object
                                         if (!fromDate || !value) {
                                         return true; // Skip validation if fromDate or toDate is not set
                                      }
                                      return fromDate <= value; // Validate if toDate is after or equal to fromDate
                                    }),
                      emailTo: Yup.string().email('Email non è valida'),
                      idcli:  Yup.string().required('Seleziona Cliente'),
                      ditta:  Yup.string().required('Seleziona Ditta'),
                    });




export async function jasperReportClientiVersoreBlob( fromDate: Date, toDate: Date, ditta: String, codcli: String, formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }

    // check codcli = 0 for admin

      const mycodcli = codcli === '0' ? '' : codcli;


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/repcliversore${formato}.${formato}?${pag}datainizio=${fromDateString}&datafine=${toDateString}&codcli=${mycodcli}&ditta=${ditta}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};







